import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackBubbleShow } from './tracking';
import { BubbleMessage } from '../../components/BubbleMessage';
import { currentOpenChatIDSelector } from '../../selectors';
import { TMessageBubble } from '../../types/messageBubble';
import { useApplicationContext } from '../../utils/applicationContext';
import { isMessageBubblesEnabled as _isMessageBubblesEnabled } from '../../utils/isMessageBubblesEnabled';
import { BubbleButtonContainer } from '../BubbleButtonContainer';
import { BubbleInputContainer } from '../BubbleInputContainer';

type TBubbleMessageContainerProps = {
  messageId: string;
  bubble: TMessageBubble;
};

export const BubbleMessageContainer: React.VFC<TBubbleMessageContainerProps> = ({ bubble, messageId }) => {
  const { title, textField, buttons, analyticsBubbleType } = bubble;

  const { config } = useApplicationContext();
  const chatId = useSelector(currentOpenChatIDSelector) as string;
  const isMessageBubblesEnabled = _isMessageBubblesEnabled(config);

  React.useEffect(() => {
    if (isMessageBubblesEnabled) {
      trackBubbleShow(chatId, analyticsBubbleType);
    }
  }, [analyticsBubbleType, chatId, isMessageBubblesEnabled]);

  const buttonsNode = React.useMemo(() => {
    if (!buttons?.length) {
      return null;
    }

    return buttons.map(button => (
      <BubbleButtonContainer
        key={button.text}
        messageId={messageId}
        button={button}
        analyticsBubbleType={analyticsBubbleType}
      />
    ));
  }, [analyticsBubbleType, buttons, messageId]);

  if (!isMessageBubblesEnabled) {
    return null;
  }

  return (
    <BubbleMessage
      title={title}
      buttonsNode={buttonsNode}
      textFieldNode={
        textField ? (
          <BubbleInputContainer messageId={messageId} textField={textField} analyticsBubbleType={analyticsBubbleType} />
        ) : null
      }
    />
  );
};
